import React from "react";
import { useHistory } from "react-router";

const Waitarea = () => {
  const history = useHistory();

  function myFunction() {
    history.push("/sendmoney");
  }

  window.onload = function () {
    var reloading = sessionStorage.getItem("reloading");
    if (reloading) {
      sessionStorage.removeItem("reloading");
      myFunction();
    }
  };

  function reloadP() {
    sessionStorage.setItem("reloading", "true");
    document.location.reload();
  }

  return (
    <div className="text-center">
      <h2>Please Wait...</h2>
      <h5 style={{ marginBottom: 100 }}>
        Kindly hold on as we determine the status of your transaction
      </h5>
      <div
        className="btn-wide mb-8 mr-2 btn btn-shadow btn-danger btn-lg"
        onClick={reloadP}
        style={{ marginBottom: 400, textAlign: "center" }}
      >
        Go back to JCI App
      </div>
    </div>
  );
};

export default Waitarea;
